module.exports = __webpack_public_path__ + "img/04 Animation 2-squashed.70edbe05.jpg";